import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const BULK_OPERATION_TYPE = {
    REPLACE: 'REPLACE',
    APPEND: 'APPEND',
    REMOVE: 'REMOVE',
};

export const REPLACE_OPTION = {
    label: (
        <FormattedMessage id="campaign.bulk.edit.preview.action.dropdown.option.override" defaultMessage="Override" />
    ),
    value: BULK_OPERATION_TYPE.REPLACE,
};

const APPEND_OPTION = {
    label: <FormattedMessage id="campaign.bulk.edit.preview.action.dropdown.option.add" defaultMessage="Add" />,
    value: BULK_OPERATION_TYPE.APPEND,
};

const REMOVE_OPTION = {
    label: <FormattedMessage id="campaign.bulk.edit.preview.action.dropdown.option.remove" defaultMessage="Remove" />,
    value: BULK_OPERATION_TYPE.REMOVE,
};

export const DEFAULT_OPERATION_TYPE_OPTIONS = [REPLACE_OPTION, APPEND_OPTION, REMOVE_OPTION];

export const createOperationTypeOptionsWithConfigs = ({
    [BULK_OPERATION_TYPE.REPLACE]: replaceConfig,
    [BULK_OPERATION_TYPE.APPEND]: appendConfig,
    [BULK_OPERATION_TYPE.REMOVE]: removeConfig,
}) => {
    return [
        ...(replaceConfig != null ? [{ ...REPLACE_OPTION, ...replaceConfig }] : []),
        ...(appendConfig != null ? [{ ...APPEND_OPTION, ...appendConfig }] : []),
        ...(removeConfig != null ? [{ ...REMOVE_OPTION, ...removeConfig }] : []),
    ];
};
